module.exports = __webpack_public_path__ + "static/img/Insights.bf7a1095.png";